import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-file-assets-note-section',
  templateUrl: './file-assets-note-section.component.html',
  styleUrls: ['./file-assets-note-section.component.scss']
})
export class FileAssetsNoteSectionComponent implements OnInit {
  @Input() noteSections: NoteSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
